import React, { useState, useContext } from "react";
import Header from '../../components/Header';
import NumberComponent from '../../components/NumberComponent';
import TableComponent from '../../components/TableComponent';
import MultiSelectComponent from '../../components/MultiSelectComponent';
import DatePickerComponent from '../../components/DatePickerComponent';
import TextComponent from '../../components/TextComponent';
import Dashboard from '../../components/Dashboard';
import PageHeaderComponent from '../../components/PageHeaderComponent';
import OmnitechQueries from '../../queries/OmnitechQueries'
import { CubeJSContext } from '../../context/CubeJSProvider';
import { useTranslation } from 'react-i18next';
import { useCubeQuery } from '@cubejs-client/react';
import { format } from 'date-fns'

const applyFilter = (query, storeFilter, storeMember, languageFilter, languageMember) => {
  let storeCodeFilterObj = {
    member: storeMember,
    operator: "equals",
    values: storeFilter
  }

  query = {
    ...query,
    filters: (query.filters || []).concat(storeCodeFilterObj)
  }

  if (languageFilter && languageMember){
    let locateFilterObj = {
      member: languageMember,
      operator: "equals",
      values: [languageFilter]
    }
    query = {
      ...query,
      filters: (query.filters || []).concat(locateFilterObj)
    }
  }

  return query
}

const DayEndSummaryQueries = (storeFilter, startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  var result = {}
  let query1 = {
    ...OmnitechQueries.orders.OrderTotalDayEnd.query,
    "timeDimensions": OmnitechQueries.orders.OrderTotalDayEnd.query.timeDimensions.concat(
      {
        "dimension": "OrderDayEnd.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      })
  }
  query1 = applyFilter(query1, storeFilter, "OrderDayEnd.shipmentStoreCode", null, null)
  if(isRefresh)
    query1 = {}
  result["order"] = useCubeQuery(query1, {resetResultSetOnChange: true})

  let query2 = {
    ...OmnitechQueries.orders.VoidOrderTotalDayEnd.query,
    "timeDimensions": OmnitechQueries.orders.VoidOrderTotalDayEnd.query.timeDimensions.concat(
      {
        "dimension": "OrderDayEnd.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      })
  }
  query2 = applyFilter(query2, storeFilter, "OrderDayEnd.shipmentStoreCode", null, null)
  if(isRefresh)
    query2 = {}
  result["void_order"] = useCubeQuery(query2, {resetResultSetOnChange: true})

  let query3 = {
    ...OmnitechQueries.orders.TipDayEnd.query,
    "timeDimensions": OmnitechQueries.orders.TipDayEnd.query.timeDimensions.concat(
      {
        "dimension": "Orders.completedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      })
  }
  query3 = applyFilter(query3, storeFilter, "Orders.shipmentStoreCode", null, null)
  if(isRefresh)
    query3 = {}
  result["tip"] = useCubeQuery(query3, {resetResultSetOnChange: true})

  let query4 = {
    ...OmnitechQueries.orders.VoidItemDayEnd.query,
    "timeDimensions": OmnitechQueries.orders.VoidItemDayEnd.query.timeDimensions.concat(
      {
        "dimension": "CartLinePropertiesDayEnd.softDeletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      })
  }
  query4 = applyFilter(query4, storeFilter, "CartLinePropertiesDayEnd.storeCode", null, null)
  if(isRefresh)
    query4 = {}
  result["void_item"] = useCubeQuery(query4, {resetResultSetOnChange: true})

  let query5 = {
    ...OmnitechQueries.carts.OutstandingTableNetSales.query,
    "timeDimensions": [
      {
        "dimension": "Carts.createdAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ]
  }
  query5 = applyFilter(query5, storeFilter, "Carts.storeCode", null, null)
  if(isRefresh)
    query5 = {}
  result["outstanding"] = useCubeQuery(query5, {resetResultSetOnChange: true})
  

  let query6 = {
    ...OmnitechQueries.orders.OrderTotalDayEndEM.query,
    "timeDimensions": OmnitechQueries.orders.OrderTotalDayEndEM.query.timeDimensions.concat(
      {
        "dimension": "OrderDayEndEM.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      })
  }
  query6 = applyFilter(query6, storeFilter, "OrderDayEndEM.shipmentStoreCode", null, null)
  if(isRefresh)
    query6 = {}
  result["average"] = useCubeQuery(query6, {resetResultSetOnChange: true})

  if(isRefresh)
    setRefresh(false)
  return result
}

const NetSalesByStoreQuery = (storeFilter, startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  let item = {
    name: t('page.fnb.dailyOperation.netSalesByStore.name'),
    tableHeaders: {
      "OrderDayEnd.count": { name: t('page.fnb.dailyOperation.netSalesByStore.tableHeader.count'), type: "number" },
      "OrderDayEnd.orderTotal":  { name: t('page.fnb.dailyOperation.netSalesByStore.tableHeader.orderTotal'), type: "number" },
      "OrderDayEnd.shipmentStoreCode":  { name: t('page.fnb.dailyOperation.netSalesByStore.tableHeader.shipFromStoreCode'), type: "string" },
      "OrderDayEnd.orderSource":  { name: t('page.fnb.dailyOperation.netSalesByStore.tableHeader.orderSource'), type: "string" }
    },
    grid: { xs: 12, md: 6 },
    export: { allowExport: true, filename: 'net_sales_by_store_export_' + format(startDateFilter, 'yyyyMMddHHmmss') + 
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orders.NetSalesByStore.query,
    "timeDimensions": [
      {
        "dimension": "OrderDayEnd.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, "OrderDayEnd.shipmentStoreCode", null, null)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const NetSalesByStoreEMQuery = (storeFilter, startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  let item = {
    name: t('page.fnb.dailyOperation.netSalesByStoreEM.name'),
    tableHeaders: {
      "OrderDayEnd.count": { name: t('page.fnb.dailyOperation.netSalesByStoreEM.tableHeader.count'), type: "number" },
      "OrderDayEnd.netSales":  { name: t('page.fnb.dailyOperation.netSalesByStoreEM.tableHeader.netSales'), type: "number" },
      "OrderDayEnd.shipmentStoreCode":  { name: t('page.fnb.dailyOperation.netSalesByStoreEM.tableHeader.shipFromStoreCode'), type: "string" },
      "OrderDayEnd.orderSource":  { name: t('page.fnb.dailyOperation.netSalesByStoreEM.tableHeader.orderSource'), type: "string" }
    },
    grid: { xs: 12, md: 6 },
    export: { allowExport: true, filename: 'net_sales_by_store_exclude_membership_export_' + format(startDateFilter, 'yyyyMMddHHmmss') + 
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orders.NetSalesByStoreEM.query,
    "timeDimensions": [
      {
        "dimension": "OrderDayEnd.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, "OrderDayEnd.shipmentStoreCode", null, null)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const PaymentByStoreTypeQuery = (storeFilter, startDateFilter, endDateFilter, languageFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }

  let item = {
    name: t('page.fnb.dailyOperation.paymentByStoreType.name'),
    tableHeaders: {
      "PaymentRequests.sumAmount": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.sumAmount'), type: "number" },
      "PaymentRequests.sumTip": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.sumTip'), type: "number" },
      "PaymentRequests.sumGrandTotal": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.grandTotal'), type: "number" },
      "Orders.count": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.countOrderId'), type: "number" },
      "Orders.shipmentStoreCode": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.shipmentsFromStoreCode'), type: "string" },
      "PaymentProviders.code": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.paymentProviderCode'), type: "string" },
      "PaymentProviderTranslations.name": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.name'), type: "string" },
      "Currencies.code": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.currencyCode'), type: "string" },
      "PaymentRequests.state": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.state'), type: "string" },
    },
    grid: { xs: 12 },
    export: { allowExport: true, filename: 'payment_by_store_and_type_export_' + format(startDateFilter, 'yyyyMMddHHmmss') + 
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orders.PaymentByStoreType.query,
    "timeDimensions": [
      {
        "dimension": "Orders.completedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, "Orders.shipmentStoreCode", languageFilter, "PaymentProviderTranslations.locale")
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const TenderByStoreStaffQuery = (storeFilter, startDateFilter, endDateFilter, languageFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  let item = {
    name: t('page.fnb.dailyOperation.tenderByStoreStaff.name'),
    tableHeaders: {
      "PaymentRequests.sumAmount": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.sumAmount'), type: "number" },
      "PaymentRequests.sumTip": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.sumTip'), type: "number" },
      "PaymentRequests.sumGrandTotal": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.grandTotal'), type: "number" },
      "Orders.count": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.countOrderId'), type: "number" },
      "Orders.shipmentStoreCode": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.shipmentsFromStoreCode'), type: "string" },
      "InternalAppOperators.staffNumber": { name: t('page.fnb.dailyOperation.tenderByStoreStaff.tableHeader.staffNumber'), type: "string" },
      "InternalAppOperators.firstName": { name: t('page.fnb.dailyOperation.tenderByStoreStaff.tableHeader.firstName'), type: "string" },
      "InternalAppOperators.lastName": { name: t('page.fnb.dailyOperation.tenderByStoreStaff.tableHeader.lastName'), type: "string" },
      "PaymentProviders.code": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.paymentProviderCode'), type: "string" },
      "PaymentProviderTranslations.name": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.name'), type: "string" },
      "Currencies.code": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.currencyCode'), type: "string" },
      "PaymentRequests.state": { name: t('page.fnb.dailyOperation.paymentByStoreType.tableHeader.state'), type: "string" },
    },
    grid: { xs: 12 },
    export: { allowExport: true, filename: 'payment_by_store_and_type_export_' + format(startDateFilter, 'yyyyMMddHHmmss') + 
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orders.TenderByStoreStaff.query,
    "timeDimensions": [
      {
        "dimension": "Orders.completedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, "Orders.shipmentStoreCode", languageFilter, "PaymentProviderTranslations.locale")
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const DiscountBreakdownQuery = (storeFilter, startDateFilter, endDateFilter, languageFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }

  let item = {
    name: t('page.fnb.dailyOperation.discountBreakdown.name'),
    tableHeaders: {
      "OrderTransactionsDiscount.storeCode": { name: t('page.fnb.dailyOperation.discountBreakdown.tableHeader.shipFromStoreCode'), type: 'string'},
      "OrderTransactionsDiscount.discountCode": { name: t('page.fnb.dailyOperation.discountBreakdown.tableHeader.discountCode'), type: 'string'},
      "OrderTransactionsDiscount.discountName": { name: t('page.fnb.dailyOperation.discountBreakdown.tableHeader.discountName'), type: 'string'},
      "OrderTransactionsDiscount.totalAmount": { name: t('page.fnb.dailyOperation.discountBreakdown.tableHeader.lineTotal'), type: 'number'},
      "OrderTransactionsDiscount.sumQuantity": { name: t('page.fnb.dailyOperation.discountBreakdown.tableHeader.quantity'), type: 'number'},
    },
    grid: { xs: 12 },
    export: { allowExport: true, filename: 'discount_breakdown_export_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orders.DiscountBreakdown.query,
    "timeDimensions": [
      {
        "dimension": "OrderTransactionsDiscount.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, "OrderTransactionsDiscount.storeCode", languageFilter, "OrderTransactionsDiscount.discountLocale")
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const SKUSalesDetailsQuery = (storeFilter, startDateFilter, endDateFilter, languageFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  let item = {
    name: t('page.fnb.dailyOperation.SKUSalesDetails.name'),
    tableHeaders: {
      "SKUSalesTransactions.shipFromStoreCode": { name: t('page.fnb.dailyOperation.SKUSalesDetails.tableHeader.shipFromStoreCode'), type: 'string'},
      "SKUSalesTransactions.skuCode": { name: t('page.fnb.dailyOperation.SKUSalesDetails.tableHeader.skuCode'), type: 'string'},
      "SKUSalesTransactions.skuInternalUseTitle": { name: t('page.fnb.dailyOperation.SKUSalesDetails.tableHeader.skuInternalUseTitle'), type: 'string'},
      "ProductTranslations.title": { name: t('page.fnb.dailyOperation.SKUSalesDetails.tableHeader.productTitle'), type: 'string'},
      "SKUSalesTransactions.skuCost": { name: t('page.fnb.dailyOperation.SKUSalesDetails.tableHeader.skuCost'), type: 'number'},
      "ViewReportCategoryProductsFlatten.code":  { name: t('page.fnb.dailyOperation.SKUSalesDetails.tableHeader.code'), type: "string" },
      "SKUSalesTransactions.totalAmount": { name: t('page.fnb.dailyOperation.SKUSalesDetails.tableHeader.lineTotal'), type: 'number'},
      "SKUSalesTransactions.sumQuantity": { name: t('page.fnb.dailyOperation.SKUSalesDetails.tableHeader.quantity'), type: 'number'},
    },
    grid: { xs: 12 },
    export: { allowExport: true, filename: 'sku_sales_details_export_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orderTransactions.SKUSalesDetails.query,
    "timeDimensions": [
      {
        "dimension": "SKUSalesTransactions.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, "SKUSalesTransactions.shipFromStoreCode", languageFilter, "ProductTranslations.locale")
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const HighlightCategorySalesQuery = (storeFilter, startDateFilter, endDateFilter, languageFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  let item = {
    name: t('page.fnb.dailyOperation.HighlightCategorySales.name'),
    tableHeaders: {
      "SKUSalesTransactions.skuCode": { name: t('page.fnb.dailyOperation.HighlightCategorySales.tableHeader.skuCode'), type: 'string'},
      "SKUSalesTransactions.skuInternalUseTitle": { name: t('page.fnb.dailyOperation.HighlightCategorySales.tableHeader.skuInternalUseTitle'), type: 'string'},
      "ProductTranslations.title": { name: t('page.fnb.dailyOperation.HighlightCategorySales.tableHeader.productTitle'), type: 'string'},
      "ViewReportCategoryProductsFlatten.code":  { name: t('page.fnb.dailyOperation.HighlightCategorySales.tableHeader.code'), type: "string" },
      "Categories.code": { name: t('page.fnb.dailyOperation.HighlightCategorySales.tableHeader.type'), type: "string" },
      "SKUSalesTransactions.totalAmount": { name: t('page.fnb.dailyOperation.HighlightCategorySales.tableHeader.lineTotal'), type: 'number'},
      "SKUSalesTransactions.sumQuantity": { name: t('page.fnb.dailyOperation.HighlightCategorySales.tableHeader.quantity'), type: 'number'},
    },
    grid: { xs: 12 },
    export: { allowExport: true, filename: 'highlight_category_sales_export_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orderTransactions.HighlightCategorySales.query,
    "timeDimensions": [
      {
        "dimension": "SKUSalesTransactions.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, "SKUSalesTransactions.shipFromStoreCode", languageFilter, "ProductTranslations.locale")
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const MembershipSalesByTypeQuery = (storeFilter, startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  let item = {
    name: t('page.fnb.dailyOperation.MembershipSalesByType.name'),
    tableHeaders: {
      "OrderTransactionsWOPayment.shipFromStoreCode": { name: t('page.fnb.dailyOperation.MembershipSalesByType.tableHeader.shipFromStoreCode'), type: 'string'},
      "OrderTransactionsWOPayment.skuCode": { name: t('page.fnb.dailyOperation.MembershipSalesByType.tableHeader.skuCode'), type: 'string'},
      "OrderTransactionsWOPayment.skuInternalUseTitle": { name: t('page.fnb.dailyOperation.MembershipSalesByType.tableHeader.skuInternalUseTitle'), type: 'string'},
      "OrderTransactionsWOPayment.totalAmount": { name: t('page.fnb.dailyOperation.MembershipSalesByType.tableHeader.lineTotal'), type: 'number'},
      "OrderTransactionsWOPayment.sumQuantity": { name: t('page.fnb.dailyOperation.MembershipSalesByType.tableHeader.quantity'), type: 'number'},
    },
    grid: { xs: 12 },
    export: { allowExport: true, filename: 'membership_sales_by_type_export_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orderTransactions.MembershipSalesByType.query,
    "timeDimensions": [
      {
        "dimension": "OrderTransactionsWOPayment.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, "OrderTransactionsWOPayment.shipFromStoreCode", null, null)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const MembershipSalesDetailQuery = (storeFilter, startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  let item = {
    name: t('page.fnb.dailyOperation.MembershipSalesDetails.name'),
    tableHeaders: {
      "OrderTransactionsSales.shipFromStoreCode": { name: t('page.fnb.dailyOperation.MembershipSalesDetails.tableHeader.shipFromStoreCode'), type: 'string'},
      "OrderTransactionsSales.skuCode": { name: t('page.fnb.dailyOperation.MembershipSalesDetails.tableHeader.skuCode'), type: 'string'},
      "OrderTransactionsSales.skuInternalUseTitle": { name: t('page.fnb.dailyOperation.MembershipSalesDetails.tableHeader.skuInternalUseTitle'), type: 'string'},
      "InternalAppOperators.staffNumber": { name: t('page.fnb.dailyOperation.MembershipSalesDetails.tableHeader.staffNumber'), type: 'string'},
      "InternalAppOperators.firstName": { name: t('page.fnb.dailyOperation.MembershipSalesDetails.tableHeader.firstName'), type: 'string'},
      "InternalAppOperators.lastName": { name: t('page.fnb.dailyOperation.MembershipSalesDetails.tableHeader.lastName'), type: 'string'},
      "OrderTransactionsSales.orderCompletedAt": { name: t('page.fnb.dailyOperation.MembershipSalesDetails.tableHeader.ordersCompletedAt'), type: 'dateTime'},
      "OrderTransactionsSales.unitAmount": { name: t('page.fnb.dailyOperation.MembershipSalesDetails.tableHeader.unitAmount'), type: 'number'},
      "OrderTransactionsSales.quantity": { name: t('page.fnb.dailyOperation.MembershipSalesDetails.tableHeader.quantity'), type: 'number'},
      "OrderTransactionsSales.lineTotal": { name: t('page.fnb.dailyOperation.MembershipSalesDetails.tableHeader.lineTotal'), type: 'number'},
    },
    grid: { xs: 12 },
    export: { allowExport: true, filename: 'membership_sales_details_export_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orderTransactions.MembershipSalesDetailQuery.query,
    "timeDimensions": [
      {
        "dimension": "OrderTransactionsSales.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, "OrderTransactionsSales.shipFromStoreCode", null, null)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const MembershipTenderSummariesQuery = (storeFilter, startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  let item = {
    name: t('page.fnb.dailyOperation.MembershipTenderSummaries.name'),
    tableHeaders: {
      "OrderTransactionsSales.shipFromStoreCode": { name: t('page.fnb.dailyOperation.MembershipTenderSummaries.tableHeader.shipFromStoreCode'), type: 'string'},
      "PaymentProviders.code": { name: t('page.fnb.dailyOperation.MembershipTenderSummaries.tableHeader.paymentProviderCode'), type: 'string'},
      "OrderTransactionsSales.totalAmount": { name: t('page.fnb.dailyOperation.MembershipTenderSummaries.tableHeader.lineTotal'), type: 'number'},
      "OrderTransactionsSales.sumQuantity": { name: t('page.fnb.dailyOperation.MembershipTenderSummaries.tableHeader.quantity'), type: 'number'},
    },
    grid: { xs: 12 },
    export: { allowExport: true, filename: 'membership_tender_summaries_export_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orderTransactions.MembershipTenderSummaries.query,
    "timeDimensions": [
      {
        "dimension": "OrderTransactionsSales.orderCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter, "OrderTransactionsSales.shipFromStoreCode", null, null)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const DailyOperationPage = () => {
  const { t, i18n } = useTranslation();
  let languageFilter = i18n.language
  if(languageFilter !== 'en-HK' && languageFilter !== 'zh-HK')
    languageFilter = 'en-HK'
  const context = useContext(CubeJSContext);
  let storeCodeSelect = []
  if(context.storeCodes)
    storeCodeSelect = context.storeCodes
  const [ storeFilter, setStoreFilter ] = useState([]);
  let filterStartDate = new Date()
  filterStartDate.setHours(0,0,0,0);
  let filterEndDate = new Date()
  filterEndDate.setHours(23,59,59,999);
  const [dateRangeFilter, setDateRangeFilter] = useState([filterStartDate, filterEndDate])
  const [startDateFilter, endDateFilter] = dateRangeFilter
  const item = { grid: { xs: 12, sm: 6, md: 4 }}
  const [rowsPerPage1, setRowsPerPage1] = useState(10);
  const [page1, setPage1] = useState(0);
  const [rowsPerPage2, setRowsPerPage2] = useState(10);
  const [page2, setPage2] = useState(0);
  const [rowsPerPage3, setRowsPerPage3] = useState(10);
  const [page3, setPage3] = useState(0);
  const [rowsPerPage4, setRowsPerPage4] = useState(10);
  const [page4, setPage4] = useState(0);
  const [rowsPerPage5, setRowsPerPage5] = useState(10);
  const [page5, setPage5] = useState(0);
  const [rowsPerPage6, setRowsPerPage6] = useState(10);
  const [page6, setPage6] = useState(0);
  const [rowsPerPage7, setRowsPerPage7] = useState(10);
  const [page7, setPage7] = useState(0);
  const [rowsPerPage8, setRowsPerPage8] = useState(10);
  const [page8, setPage8] = useState(0);
  const [rowsPerPage9, setRowsPerPage9] = useState(10);
  const [page9, setPage9] = useState(0);
  const [rowsPerPage10, setRowsPerPage10] = useState(10);
  const [page10, setPage10] = useState(0);

  const [ refresh1, setRefresh1 ] = useState(false);
  const [ refresh2, setRefresh2 ] = useState(false);
  const [ refresh3, setRefresh3 ] = useState(false);
  const [ refresh4, setRefresh4 ] = useState(false);
  const [ refresh5, setRefresh5 ] = useState(false);
  const [ refresh6, setRefresh6 ] = useState(false);
  const [ refresh7, setRefresh7 ] = useState(false);
  const [ refresh8, setRefresh8 ] = useState(false);
  const [ refresh9, setRefresh9 ] = useState(false);
  const [ refresh10, setRefresh10 ] = useState(false);
  const [ refresh11, setRefresh11 ] = useState(false);

  const resultSets = DayEndSummaryQueries(storeFilter, startDateFilter, endDateFilter, refresh1, setRefresh1)
  const query1 = NetSalesByStoreQuery(storeFilter, startDateFilter, endDateFilter, refresh2, setRefresh2)
  const query2 = NetSalesByStoreEMQuery(storeFilter, startDateFilter, endDateFilter, refresh3, setRefresh3)
  const query3 = PaymentByStoreTypeQuery(storeFilter, startDateFilter, endDateFilter, languageFilter, refresh4, setRefresh4)
  const query4 = TenderByStoreStaffQuery(storeFilter, startDateFilter, endDateFilter, languageFilter, refresh5, setRefresh5)
  const query5 = DiscountBreakdownQuery(storeFilter, startDateFilter, endDateFilter, languageFilter, refresh6, setRefresh6)
  const query6 = SKUSalesDetailsQuery(storeFilter, startDateFilter, endDateFilter, languageFilter, refresh7, setRefresh7)
  const query7 = HighlightCategorySalesQuery(storeFilter, startDateFilter, endDateFilter, languageFilter, refresh8, setRefresh8)
  const query8 = MembershipSalesByTypeQuery(storeFilter, startDateFilter, endDateFilter, refresh9, setRefresh9)
  const query9 = MembershipSalesDetailQuery(storeFilter, startDateFilter, endDateFilter, refresh10, setRefresh10)
  const query10 = MembershipTenderSummariesQuery(storeFilter, startDateFilter, endDateFilter, refresh11, setRefresh11)

  const refresh = () => {
    setRefresh1(true)
    setRefresh2(true)
    setRefresh3(true)
    setRefresh4(true)
    setRefresh5(true)
    setRefresh6(true)
    setRefresh7(true)
    setRefresh8(true)
    setRefresh9(true)
    setRefresh10(true)
    setRefresh11(true)
    setPage1(0)
    setPage2(0)
    setPage3(0)
    setPage4(0)
    setPage5(0)
    setPage6(0)
    setPage7(0)
    setPage8(0)
    setPage9(0)
    setPage10(0)
  }

  return ([
    <Header />,
    <PageHeaderComponent onClickFunc={refresh} refreshlabel={t('component.refresh')} headerTitle={t('component.header.menu.dailyOperation')} />,
    <Dashboard>
      <MultiSelectComponent id={"store_code_filter"} state={storeFilter} pageChangerArr={[setPage1,setPage2,setPage3,setPage4,setPage5,setPage6,setPage7,setPage8,setPage9,setPage10]}
          stateChanger={setStoreFilter} textLabel={t('page.fnb.dailyOperation.filter.store.name')} selectArray={storeCodeSelect}/>
      <DatePickerComponent state={dateRangeFilter} stateChanger={setDateRangeFilter} 
        pageChangerArr={[setPage1,setPage2,setPage3,setPage4,setPage5,setPage6,setPage7,setPage8,setPage9,setPage10]} 
        dateLabel={t('page.fnb.dailyOperation.filter.orderCompletedAt.date')}/>
    </Dashboard>,
    <Dashboard>
      <NumberComponent item={item} query={resultSets["order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalRevenue')}
        fieldName="OrderDayEnd.orderTotal" />
      <NumberComponent item={item} query={resultSets["order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalMembershipSales')}
        fieldName="OrderDayEnd.membershipCharges" />
      <NumberComponent item={item} query={resultSets["order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalNetSales')}
        fieldName="OrderDayEnd.netSales" />
      <NumberComponent item={item} query={resultSets["average"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalOrder')}
        fieldName="OrderDayEndEM.count" />
      <NumberComponent item={item} query={resultSets["average"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.avgBillAmount')}
        fieldName="OrderDayEndEM.avgBillAmount" />
      <NumberComponent item={item} query={resultSets["average"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalPax')}
        fieldName="OrderDayEndEM.pax" />
      <NumberComponent item={item} query={resultSets["average"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.perPersonSpending')}
        fieldName="OrderDayEndEM.perPersonSpending" />
      <NumberComponent item={item} query={resultSets["order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalGrossSales')}
        fieldName="OrderDayEnd.grossSales" />
      <NumberComponent item={item} query={resultSets["order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalDiscounts')}
        fieldName="OrderDayEnd.discounts" />
      <NumberComponent item={item} query={resultSets["void_item"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalVoidItem')}
        fieldName="CartLinePropertiesDayEnd.sumCachedCalculationQuantity" />
      <NumberComponent item={item} query={resultSets["tip"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalTip')}
        fieldName="PaymentRequests.sumTip" />
      <NumberComponent item={item} query={resultSets["void_order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalVoidOrder')}
        fieldName="OrderDayEnd.count" />
      <NumberComponent item={item} query={resultSets["void_order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalVoidOrderAmount')}
        fieldName="OrderDayEnd.orderTotal" />
      <NumberComponent item={item} query={resultSets["order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalServiceCharges')}
        fieldName="OrderDayEnd.serviceCharges" />
      <NumberComponent item={item} query={resultSets["order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalShippingFees')}
        fieldName="OrderDayEnd.shippingFees" />
      <NumberComponent item={item} query={resultSets["order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalOrderAmountRounding')}
        fieldName="OrderDayEnd.orderAmountRounding" />
      <NumberComponent item={item} query={resultSets["outstanding"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.outStandingNetsales')}
        fieldName="CartTransactions.sumLineTotal" />
      <NumberComponent item={item} query={resultSets["order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalFoodGrossSales')}
        fieldName="OrderDayEnd.foodGrossSales" />
      <NumberComponent item={item} query={resultSets["order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalBeverageGrossSales')}
        fieldName="OrderDayEnd.beverageGrossSales" />
      <NumberComponent item={item} query={resultSets["order"]}
        titleName={t('page.fnb.dailyOperation.titleMapping.totalOtherGrossSales')}
        fieldName="OrderDayEnd.otherGrossSales" />
      <TextComponent title={""} xs={12} lg={8} transparent={true}/>
      <TableComponent item={query1.item} result={query1.result} rowsPerPage={rowsPerPage1} 
        setRowsPerPage={setRowsPerPage1} page={page1} setPage={setPage1}/>
      <TableComponent item={query2.item} result={query2.result} rowsPerPage={rowsPerPage2} 
        setRowsPerPage={setRowsPerPage2} page={page2} setPage={setPage2}/>
      <TableComponent item={query3.item} result={query3.result} rowsPerPage={rowsPerPage3} 
        setRowsPerPage={setRowsPerPage3} page={page3} setPage={setPage3}/>
      <TableComponent item={query4.item} result={query4.result} rowsPerPage={rowsPerPage4} 
        setRowsPerPage={setRowsPerPage4} page={page4} setPage={setPage4}/>
      <TableComponent item={query5.item} result={query5.result} rowsPerPage={rowsPerPage5} 
        setRowsPerPage={setRowsPerPage5} page={page5} setPage={setPage5}/>
      <TableComponent item={query6.item} result={query6.result} rowsPerPage={rowsPerPage6} 
        setRowsPerPage={setRowsPerPage6} page={page6} setPage={setPage6}/>
      <TableComponent item={query7.item} result={query7.result} rowsPerPage={rowsPerPage7} 
        setRowsPerPage={setRowsPerPage7} page={page7} setPage={setPage7}/>
      <TextComponent title={t('page.fnb.dailyOperation.text.tenderWarning')} xs={12} lg={12}/>
      <TableComponent item={query8.item} result={query8.result} rowsPerPage={rowsPerPage8} 
        setRowsPerPage={setRowsPerPage8} page={page8} setPage={setPage8}/>
      <TableComponent item={query9.item} result={query9.result} rowsPerPage={rowsPerPage9} 
        setRowsPerPage={setRowsPerPage9} page={page9} setPage={setPage9}/>
      <TextComponent title={t('component.text.paymentBreakdownMapping')} 
        contentArray={[t('page.fnb.dailyOperation.text.paymentCodeMapping.vsm'),
        t('page.fnb.dailyOperation.text.paymentCodeMapping.msm'),
        t('page.fnb.dailyOperation.text.paymentCodeMapping.CV'),
        t('page.fnb.dailyOperation.text.paymentCodeMapping.CU'),
        t('page.fnb.dailyOperation.text.paymentCodeMapping.aem'),
        t('page.fnb.dailyOperation.text.paymentCodeMapping.CASH_HKD'),
        t('page.fnb.dailyOperation.text.paymentCodeMapping.octopus'),
        t('page.fnb.dailyOperation.text.paymentCodeMapping.alipay_hkd_manual'),
        t('page.fnb.dailyOperation.text.paymentCodeMapping.wechat_pay_hkd_manual')]} xs={12} lg={12}/>
      <TableComponent item={query10.item} result={query10.result} rowsPerPage={rowsPerPage10} 
        setRowsPerPage={setRowsPerPage10} page={page10} setPage={setPage10}/>
    </Dashboard>
  ]) 
};

export default DailyOperationPage;